// @ts-expect-error this library does not have type definitions and is written in commonjs
import { isValid as emailIsValid } from '@sideway/address/lib/email'
// @ts-expect-error this library does not have type definitions and is written in commonjs
import tlds from '@sideway/address/lib/tlds'

export const emailValidator = (
    onFormChanged: Function,
    values: string[],
    callback: Function,
) => {
    if (values.length === 0) {
        callback()
        onFormChanged({ error: true })
        return
    }
    const invalidInputs = values.filter(
        value => !emailIsValid(value, { tlds: { allow: tlds } }),
    )

    if (invalidInputs.length === 0) {
        callback()
        onFormChanged({ value: values })
    } else if (invalidInputs.length === 1) {
        callback(`${invalidInputs.join('')} is not a valid email`)
        onFormChanged({ error: true })
    } else {
        const joinedEmails = `${invalidInputs
            .slice(0, -1)
            .join(', ')} and ${invalidInputs.slice(-1)}`

        callback(`${joinedEmails} are not valid emails`)
        onFormChanged({ error: true })
    }
}
